const mutations = {
    setMHDInventoryDrawerState(state, data) {
        state.mhdInventoryDrawerState = data
    },
    setMHDItems(state, data) {
        state.mhdItems = data
    }
}

export default mutations
